module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/applicant.component.css
// module id = ./src/app/applicant/applicant.component.css
// module chunks = main